import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ShoppingBag } from 'lucide-react';
const notifications = [{
  flagCode: 'ar',
  countryName: 'Argentina',
  location: 'Córdoba, Argentina',
  name: 'Marcela González',
  initials: 'MG',
  time: 'hace 5 minutos'
}, {
  flagCode: 'co',
  countryName: 'Colombia',
  location: 'Bogotá, Colombia',
  name: 'Juan Ramírez',
  initials: 'JR',
  time: 'hace 12 minutos'
}, {
  flagCode: 'py',
  countryName: 'Paraguay',
  location: 'Asunción, Paraguay',
  name: 'Lorena Vargas',
  initials: 'LV',
  time: 'hace 18 minutos'
}, {
  flagCode: 'pe',
  countryName: 'Perú',
  location: 'Lima, Perú',
  name: 'Valeria Torres',
  initials: 'VT',
  time: 'hace 27 minutos'
}, {
  flagCode: 'uy',
  countryName: 'Uruguay',
  location: 'Montevideo, Uruguay',
  name: 'Carlos Ruiz',
  initials: 'CR',
  time: 'hace 41 minutos'
}];
export function PurchaseNotifications() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    if (isDismissed) return;
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 3000);
    return () => clearTimeout(initialTimer);
  }, [isDismissed]);
  useEffect(() => {
    if (isDismissed || !isVisible) return;
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => {
        if (!isDismissed) {
          setCurrentIndex(prev => (prev + 1) % notifications.length);
          setIsVisible(true);
        }
      }, 1500);
    }, 5000);
    return () => clearTimeout(hideTimer);
  }, [isVisible, isDismissed, currentIndex]);
  if (isDismissed) return null;
  const current = notifications[currentIndex];
  return <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 pointer-events-none w-full px-4 flex justify-center" data-id="element-239">
      <AnimatePresence mode="wait" data-id="element-240">
        {isVisible && <motion.div key={currentIndex} initial={{
        opacity: 0,
        y: 50,
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.9
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 25
      }} className="bg-white border border-forest/20 rounded-xl p-3.5 shadow-[0_4px_30px_rgba(30,58,36,0.15)] w-full max-w-[360px] pointer-events-auto relative" data-id="element-241">
            <button onClick={() => setIsDismissed(true)} className="absolute top-2 right-2 text-slate-400 hover:text-slate-600 transition-colors" aria-label="Cerrar" data-id="element-242">
              <X size={14} data-id="element-243" />
            </button>

            <div className="flex items-center gap-3" data-id="element-244">
              <div className="relative shrink-0" data-id="element-245">
                <div className="w-11 h-11 rounded-full bg-forest text-cream flex items-center justify-center font-bold text-sm" data-id="element-246">
                  {current.initials}
                </div>
                <img src={`https://flagcdn.com/w40/${current.flagCode}.png`} alt={`Bandera de ${current.countryName}`} className="absolute -bottom-1 -right-1 w-5 h-5 rounded-full object-cover border-2 border-white shadow" data-id="element-247" />
              </div>

              <div className="flex-1 min-w-0 pr-4" data-id="element-248">
                <div className="flex items-center gap-1.5 text-[11px] text-slate-500 mb-0.5" data-id="element-249">
                  <img src={`https://flagcdn.com/w20/${current.flagCode}.png`} alt="" className="w-4 h-3 rounded-sm object-cover" data-id="element-250" />
                  <span className="truncate" data-id="element-251">{current.location}</span>
                </div>

                <p className="text-slate-900 text-[13px] leading-snug" data-id="element-252">
                  <span className="font-bold" data-id="element-253">{current.name}</span>{' '}
                  <span className="text-slate-600" data-id="element-254">
                    compró el Mega Pack Producción Agropecuaria
                  </span>
                </p>

                <div className="flex items-center gap-1.5 text-[10px] text-forest font-medium mt-1" data-id="element-255">
                  <span className="w-1.5 h-1.5 rounded-full bg-forest animate-pulse" data-id="element-256"></span>
                  <ShoppingBag size={10} data-id="element-257" />
                  <span data-id="element-258">Compra verificada • {current.time}</span>
                </div>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}